const DashboardMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const Dashboard = () => import(/* webpackChunkName: "admin-module" */ './views/Dashboard');
const GridView = () => import(/* webpackChunkName: "admin-module" */ './views/GridView');
const Group = () => import(/* webpackChunkName: "admin-module" */ './views/tabs/Group');

export default [
    {
        path: 'dashboard',
        components: { base: DashboardMain },
        children: [
            {
                path: '',
                name: 'dashboard',
                components: { dashboard: Dashboard },
            },
            {
                path: 'grid',
                name: 'grid.view',
                components: { dashboard: GridView },
                children: [
                    {
                        path: ':group_slug',
                        name: 'dashboard.group',
                        components: { gridview: Group }
                    },
                ]
            },
        ]
    },
];
